import { CommandRequestType } from "app/services/authentication/connection/commandRequestType";
import { ICommandParameters } from "app/services/authentication/connection/iCommandParameters";
import { ICommandResponse } from "app/services/authentication/connection/iCommandResponse";
import { ErrorDetails } from "app/services/authentication/connection/interfaces/apiInterfaces";
import { IRequestCommand } from "app/services/authentication/connection/iRequestCommand";

export class GetOwnerBasicInfoCommand extends IRequestCommand<
  ICommandResponse,
  ErrorDetails,
  IGetOwnerBasicInfoCommandParameters
> {
  override _commandType: CommandRequestType = CommandRequestType.GET;
  override _commandUrl = 'carriers/{carrierId}/vehicleOwners/basicInfo/{ownerId}?userId=';

  public override setParameters(parameters: IGetOwnerBasicInfoCommandParameters) {
    this._commandUrl = this._commandUrl.replace(
      '{carrierId}',
      parameters.carrierId
    );
    this._commandUrl = this._commandUrl.replace(
      '{ownerId}',
      parameters.ownerId
    );

    if(parameters.userId)
      this._commandUrl = this._commandUrl + parameters.userId;
  }
}
export interface IGetOwnerBasicInfoCommandParameters extends ICommandParameters {
  carrierId: string;
  ownerId: string;
  userId: string;
}
